import { useBranchFilter } from "./useBranchFilter";

// The branch a NEW record's form should start on (2026-10-02, "many pages are
// still not triggering the global branch selection"): the header branch when one
// is picked and the form offers it, else the only branch when the form offers
// just one, else "" (the user must choose). `formBranches` is the form's own
// branch list - most create forms build theirs from the token claims - so a
// header branch the form does not offer is never forced onto it.
//
// Only a starting value: editing an existing record still loads that record's
// own branch, and the user can still change it on a new one.
export const useDefaultFormBranch = (formBranches) => {
  const { selectedBranchId } = useBranchFilter();
  const list = formBranches || [];
  if (selectedBranchId != null && list.some((b) => b.branchId === selectedBranchId)) return selectedBranchId;
  return list.length === 1 ? list[0].branchId : "";
};
